import React from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, GalleryField } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import Modal from "components/Modal";
import { TextArea, Select } from "components/form";
import { useCore } from "store/core";
import { CheckBox } from "components/form";
// components

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const initialValues = item;
  // ? {
  //     id: item.id,
  //     title: item.title || "",
  //     title_fa: item.title_fa || "",
  //     slug: item.slug || "",
  //     type_id: item.type?.id || "",
  //     icon_id: item.icon_id || "",
  //     image_id: item.image_id || "",
  //     color_code: item.color_code || "",
  //     is_visible: item.is_visible || false,
  //     is_active: item.is_active || false,
  //   }
  // : {
  //     title: "",
  //     title_fa: "",
  //     slug: "",
  //     type_id: "",
  //     icon_id: "",
  //     image_id: "",
  //     color_code: "",
  //     is_visible: false,
  //     is_active: false,
  //   };

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            ...initialValues,
            type_id: item.type?.id || "",
            icon_id: item?.icon?.id || "",
            image_id: item?.image?.id || "",
          }}
          onSubmit={async (values, { setSubmitting }) => {
            if (!values.parent_id) {
              delete values.parent_id;
            }
            await props.submit(values, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body py-1 gap-y-3">
                <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                  <Field
                    label="عنوان"
                    name="title_fa"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />

                  <Field
                    label="Title"
                    name="title"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />

                  <Field
                    label="Slug"
                    name="slug"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />

                  <Field
                    label="نوع"
                    name="type_id"
                    component={Select}
                    options={core?.tagsType || []}
                  />

                  <Field
                    label="آیکن"
                    name="icon_id"
                    dataType="id"
                    component={GalleryField}
                  />

                  <Field
                    label="تصویر"
                    name="image_id"
                    dataType="id"
                    component={GalleryField}
                  />

                  <Field
                    label="کد رنگ"
                    name="color_code"
                    component={TextField}
                  />

                  <Field
                    label="قابل نمایش باشد؟"
                    name="is_visible"
                    component={CheckBox}
                  />

                  <Field
                    label="فعال باشد؟"
                    name="is_active"
                    component={CheckBox}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
